
import { Component, Vue } from 'vue-property-decorator';
import QvInput from '@/components/FormComponents/QvInput.vue';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import { ValidationObserver } from 'vee-validate';
import { MapStore, BlockStore, SensorStore } from '@/store/modules';
import LocationInputMap from '@/components/Forms/Components/LocationInputMap.vue';
import { BlockSensorHistory } from '@/store/models/sensor';

@Component({
  components: {
    ValidationObserver,
    QvInput,
    QvSelect,
    LocationInputMap
  }
})
export default class BlockForm extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  blockId = 0;
  get block() {
    return JSON.parse(JSON.stringify(BlockStore.AddEditBlock));
  }

  get sensorAttached() {
    if (this.blockSensor && this.blockSensor.id) {
      return true;
    }
    return false;
  }

  get emptyBlockSensor() {
    return {} as BlockSensorHistory;
  }
  get blockSensor() {
    const blockSensor = JSON.parse(
      JSON.stringify(SensorStore.CurrentBlockSensor)
    );
    return blockSensor;
  }

  set blockSensor(blockSensor: BlockSensorHistory) {
    SensorStore.setCurrentBlockSensor(blockSensor);
  }

  get submitLabel() {
    return 'Attach';
  }

  detachDialog = false;
  get sensorLocations() {
    return SensorStore.SensorLocations.map(x => {
      return { value: x.id, label: x.locationName };
    });
  }

  async onSubmit() {
    const blockSensor = {
      block: this.blockId,
      sensorLocation: this.blockSensor.sensorLocation
    };
    SensorStore.attachSensor(blockSensor);
    this.$router.push({ name: 'BlockList' });
  }

  onReset() {
    requestAnimationFrame(() => {
      this.blockSensor = JSON.parse(JSON.stringify(this.emptyBlockSensor));
      this.$refs.observer.reset();
      setTimeout(() => {
        MapStore.stopUpdateAnimation();
      }, 600);
      this.$router.push({ name: 'BlockList' });
    });
  }

  async onDetach() {
    this.detachDialog = false;
    if (this.blockSensor && this.blockSensor.id && this.blockSensor.id != 0) {
      SensorStore.detachSensor(this.blockId);
    }
  }

  detachSensor() {
    this.detachDialog = true;
  }

  async created() {
    SensorStore.getSensorLocations();
    if (this.$route.params.blockId) {
      this.blockId = Number(this.$route.params.blockId);
      await BlockStore.getBlockById(this.blockId);
      await SensorStore.getBlockSensorByBlockId(this.blockId);
    }
  }
}
